/* eslint-disable */ import { createPresetsFactory } from '@salsita-ai/platform-project-sdk/domain';
export const createAdminPresets = createPresetsFactory();
export const generatedAdminPresets = createAdminPresets([
    {
        name: 'Default',
        rootEntityType: 'Admin',
        initialDomainEntities: [
            {
                id: 'CabinetSolidColorMaterial-1',
                type: 'CabinetSolidColorMaterial',
                name: 'Classic White',
                color: '#FFFFFF'
            },
            {
                id: 'CabinetSolidColorMaterial-2',
                type: 'CabinetSolidColorMaterial',
                name: 'Classic Black',
                color: '#000000'
            },
            {
                id: 'CabinetSolidColorMaterial-3',
                type: 'CabinetSolidColorMaterial',
                name: 'Classic Fog',
                color: '#808080'
            },
            {
                id: 'CabinetWoodTextureMaterial-1',
                type: 'CabinetWoodTextureMaterial',
                name: 'Natural Halifax Oak',
                materialName: 'lightWoodMaterial'
            },
            {
                id: 'CabinetWoodTextureMaterial-2',
                type: 'CabinetWoodTextureMaterial',
                name: 'Carbon Frozen',
                materialName: 'darkWoodMaterial'
            },
            {
                id: 'CabinetWoodTextureMaterial-3',
                type: 'CabinetWoodTextureMaterial',
                name: 'White Frozen',
                materialName: 'whiteWoodMaterial'
            },
            {
                id: 'CountertopSolidColorMaterial-1',
                type: 'CountertopSolidColorMaterial',
                name: 'Black Plastic Laminate',
                color: '#1A1A1A'
            },
            {
                id: 'CountertopSolidColorMaterial-2',
                type: 'CountertopSolidColorMaterial',
                name: 'Grey Plastic Laminate',
                color: '#8A8A8A'
            },
            {
                id: 'CountertopWoodTextureMaterial-1',
                type: 'CountertopWoodTextureMaterial',
                name: 'Butcher Block',
                materialName: 'butcherBlockMaterial'
            },
            {
                id: 'SegmentPrice-1',
                type: 'SegmentPrice',
                product_code: 'B3D24',
                material_type: 'textured',
                width: 24,
                price: 585
            },
            {
                id: 'SegmentPrice-2',
                type: 'SegmentPrice',
                product_code: 'B4D24',
                material_type: 'textured',
                width: 24,
                price: 705
            },
            {
                id: 'SegmentPrice-3',
                type: 'SegmentPrice',
                product_code: 'BFH24',
                material_type: 'textured',
                width: 24,
                price: 355
            },
            {
                id: 'SegmentPrice-4',
                type: 'SegmentPrice',
                product_code: 'W2430',
                material_type: 'textured',
                width: 24,
                price: 290
            },
            {
                id: 'SegmentPrice-5',
                type: 'SegmentPrice',
                product_code: 'T3684',
                material_type: 'textured',
                width: 36,
                price: 935
            },
            {
                id: 'SegmentPrice-6',
                type: 'SegmentPrice',
                product_code: 'T2484',
                material_type: 'textured',
                width: 24,
                price: 690
            },
            {
                id: 'SegmentPrice-7',
                type: 'SegmentPrice',
                product_code: 'B3D24',
                material_type: 'economy',
                width: 24,
                price: 515
            },
            {
                id: 'SegmentPrice-8',
                type: 'SegmentPrice',
                product_code: 'B4D24',
                material_type: 'economy',
                width: 24,
                price: 630
            },
            {
                id: 'SegmentPrice-9',
                type: 'SegmentPrice',
                product_code: 'BFH24',
                material_type: 'economy',
                width: 24,
                price: 290
            },
            {
                id: 'SegmentPrice-10',
                type: 'SegmentPrice',
                product_code: 'W2430',
                material_type: 'economy',
                width: 24,
                price: 235
            },
            {
                id: 'SegmentPrice-11',
                type: 'SegmentPrice',
                product_code: 'T3684',
                material_type: 'economy',
                width: 36,
                price: 735
            },
            {
                id: 'SegmentPrice-12',
                type: 'SegmentPrice',
                product_code: 'T2484',
                material_type: 'economy',
                width: 24,
                price: 530
            },
            {
                id: 'SegmentPrice-13',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'textured',
                width: 24,
                price: 176.4
            },
            {
                id: 'SegmentPrice-14',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'textured',
                width: 48,
                price: 341.04
            },
            {
                id: 'SegmentPrice-15',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'textured',
                width: 72,
                price: 382.16
            },
            {
                id: 'SegmentPrice-16',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'textured',
                width: 96,
                price: 652.68
            },
            {
                id: 'SegmentPrice-17',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'economy',
                width: 24,
                price: 141.12
            },
            {
                id: 'SegmentPrice-18',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'economy',
                width: 48,
                price: 235.2
            },
            {
                id: 'SegmentPrice-19',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'economy',
                width: 72,
                price: 317.52
            },
            {
                id: 'SegmentPrice-20',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'economy',
                width: 96,
                price: 382.2
            },
            {
                id: 'SegmentPrice-21',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'textured',
                width: 120,
                price: 800
            },
            {
                id: 'SegmentPrice-22',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'textured',
                width: 144,
                price: 1000
            },
            {
                id: 'SegmentPrice-23',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'textured',
                width: 168,
                price: 1200
            },
            {
                id: 'SegmentPrice-24',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'textured',
                width: 192,
                price: 1400
            },
            {
                id: 'SegmentPrice-25',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'economy',
                width: 120,
                price: 400
            },
            {
                id: 'SegmentPrice-26',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'economy',
                width: 144,
                price: 500
            },
            {
                id: 'SegmentPrice-27',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'economy',
                width: 168,
                price: 600
            },
            {
                id: 'SegmentPrice-28',
                type: 'SegmentPrice',
                product_code: 'COUNTERTOP',
                material_type: 'economy',
                width: 192,
                price: 700
            },
            {
                id: 'SegmentPrice-29',
                type: 'SegmentPrice',
                product_code: 'B24',
                material_type: 'textured',
                width: 24,
                price: 1000
            },
            {
                id: 'SegmentPrice-30',
                type: 'SegmentPrice',
                product_code: 'B24',
                material_type: 'economy',
                width: 24,
                price: 1000
            },
            {
                id: 'Admin-1',
                type: 'Admin',
                commonAdminModelVersion: 3
            }
        ]
    }
]);

//# sourceMappingURL=admin-presets.js.map